import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { PlaceholderNote } from "../components/ComingSoon";

export default function Privacy() {
  return (
    <>
      <PageHero eyebrow="Privacy" title="Privacy at TJ’s Light" testId="privacy-hero">
        <p>How this website treats your information, in plain language.</p>
      </PageHero>
      <section aria-labelledby="privacy-details-heading" className="px-4 pb-20 sm:px-8 lg:px-16">
        <div className="mx-auto max-w-3xl space-y-8">
          <Reveal>
            <h2 id="privacy-details-heading" className="font-serif text-2xl font-normal text-ink sm:text-3xl">
              What this site collects today
            </h2>
            <p className="mt-4 text-base leading-relaxed text-body">
              Right now, this website does not collect, store, or share personal
              information. The registration, volunteer, sponsor, and contact forms are
              clearly marked previews — nothing entered into them is sent or saved.
            </p>
            <p className="mt-4 text-base leading-relaxed text-body">
              Before any form goes live, this page will be updated to explain exactly
              what is collected, why, how it is kept secure, and how to ask for your
              information to be removed.
            </p>
          </Reveal>
          <Reveal>
            <h2 className="font-serif text-2xl font-normal text-ink sm:text-3xl">A note about sensitive topics</h2>
            <p className="mt-4 text-base leading-relaxed text-body">
              This website is not a crisis service and is not the right place to share an
              emergency. If you need immediate support, call or text 988, or use the 988
              Lifeline chat. If there is immediate danger, call 911.
            </p>
          </Reveal>
          <Reveal>
            <PlaceholderNote testId="privacy-full-policy-placeholder">
              <strong className="font-semibold text-ink">Full policy — to be added.</strong>{" "}
              A complete privacy policy, reviewed and approved by the foundation, will
              replace this page before any personal information is collected.
            </PlaceholderNote>
          </Reveal>
        </div>
      </section>
    </>
  );
}
